import React, { useRef } from "react";
import PropTypes from "prop-types";

import Banner from "../banners/banners";
import { NonMobileContent } from "./NonMobileContent";
import { MobileContent } from "./MobileContent";

import { StyledSiteHeader } from "./styles";

const SiteHeader = ({
    currentUser,
    transparent,
    loginLink,
    joinLink,
    handleLogOut,
    heroSearchBgColor,
    isHeroSearchV2
}) => {
    const siteHeaderRef = useRef(null);

    return (
        <>
            <Banner />
            <StyledSiteHeader
                transparent={transparent}
                heroSearchBgColor={heroSearchBgColor}
                isHeroSearchV2={isHeroSearchV2}
                ref={siteHeaderRef}
                id="site-header"
            >
                <NonMobileContent
                    siteHeaderRef={siteHeaderRef}
                    heroSearchBgColor={heroSearchBgColor}
                    isHeroSearchV2={isHeroSearchV2}
                    currentUser={currentUser}
                    transparent={transparent}
                    loginLink={loginLink}
                    joinLink={joinLink}
                    handleLogOut={handleLogOut}
                />
                <MobileContent
                    siteHeaderRef={siteHeaderRef}
                    heroSearchBgColor={heroSearchBgColor}
                    isHeroSearchV2={isHeroSearchV2}
                    currentUser={currentUser}
                    transparent={transparent}
                    loginLink={loginLink}
                    joinLink={joinLink}
                    handleLogOut={handleLogOut}
                />
            </StyledSiteHeader>
        </>
    );
};

SiteHeader.propTypes = {
    currentUser: PropTypes.object,
    transparent: PropTypes.bool,
    loginLink: PropTypes.oneOfType([PropTypes.node, PropTypes.element])
        .isRequired,
    joinLink: PropTypes.oneOfType([PropTypes.node, PropTypes.element])
        .isRequired,
    handleLogOut: PropTypes.func.isRequired,
    heroSearchBgColor: PropTypes.string,
    isHeroSearchV2: PropTypes.bool
};

export { SiteHeader };
